import { WidgetInitializer } from "../functions/widget-initializer";
import { Constants } from "../functions/constants";
import { ConfigUtils } from "../functions/config-utils";
import { ObjectUtils } from "../functions/object-utils";
import { StringUtils } from "../functions/string-utils";
import { FormValidator } from "../services/form-validator";
import { ValidationModel } from "../services/validation-model";
import Recaptcha from "../components/Recaptcha";
import SelectBranchDropdown from "../components/SelectBranchDropdown";
import PopUp from "../components/PopUp";
import '../directives/mask-phone';

var widgetInitializer = new WidgetInitializer(Constants.COMPONENTS.CUSTOMER_REGISTER);
GlobalApp.registerInitializationHandler(Constants.COMPONENTS.CUSTOMER_REGISTER, function () {
    widgetInitializer.initialize(initCustomerRegisterApp);
});

function initCustomerRegisterApp(element) {
    var config = ConfigUtils.getConfigFor(element);

    var formValidator = new FormValidator(config.validatorOptions);

    const customerValidationSchema = {
        accountType: { isRequired: true },
        countryCode: { isRequired: true },
        firstName: { isRequired: true, valueType: "firstName" },
        lastName: { isRequired: true, valueType: "lastName" },
        email: { isRequired: true, valueType: "email" },
        phone: { isRequired: true, valueType: "phone" },
        password: { isRequired: true, valueType: "password" },
        addressLine1: { isRequired: true, valueType: "address" },
        addressLine2: { isRequired: false, valueType: "address" },      
        city: { isRequired: true, valueType: "city" },
        zip: { isRequired: true, valueType: "zip" },
        postCode: { isRequired: true },
        state: { isRequired: true },     
        province: { isRequired: true }, 
        recaptcha: { isRequired: true }
    };

    let model = new ValidationModel(formValidator, customerValidationSchema);
    model.populateFrom({
                accountType: null,
                countryCode: config.usIcoCode,
                recaptcha: ''
    });

    var vueApp = new Vue({
        el: '#' + element.id,

        data: {
            model: model,
            rememberMe: true,            
            isAwaiting: false,
            showPassword: false,
            showNotHandledErrorMessage: false,
            triedToCreate: false        
        },

        computed: {
            constants: () => Constants,
            config: () => config,  
            validationModel: function () {
                return this.model.getValidationModel();
            }
        },

        methods: {
            createAccount: function () {
                var that = this;

                this.trimModel();
                var isModelValid = this.validateModel();  
                this.triedToCreate = true;
                
                if (isModelValid === false)
                    return;
                
                this.isAwaiting = true;

                GlobalApp.RdoApiClient.fetchJson("customers/register", {
                    method: 'POST',
                    jBody: this.getRegisterRequestBody()
                })
                    .then(function (registerDetails) {
                        var errorMessage = GlobalApp.ErrorHandler.handle(registerDetails);
                        if (errorMessage) {
                            var emailAlreadyInUseMassage = `Email ${that.model.email} already in use`;
                            var firstNameErrorMessage = "First Name must be max 15 characters";
                            var lastNameErrorMessage = "Last Name must be max 18 characters";
                            if (errorMessage.toLowerCase() === emailAlreadyInUseMassage.toLowerCase()) {
                                that.validationModel.email = {
                                    isValid: false,
                                    message: emailAlreadyInUseMassage
                                };
                            } else if (errorMessage === firstNameErrorMessage) {
                                that.validationModel.firstName = {
                                    isValid: false,
                                    message: firstNameErrorMessage
                                };
                            } else if (errorMessage === lastNameErrorMessage) {
                                that.validationModel.lastName = {
                                    isValid: false,
                                    message: lastNameErrorMessage
                                };
                            } else {
                                that.showNotHandledErrorMessage = true;
                            }

                            return;
                        }

                        that.login(that.model.email, that.model.password, that.rememberMe);
                    })
                    .catch(function (err) {
                        that.showNotHandledErrorMessage = true;
                        console.warn(Constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG, err);
                    })
                    .finally(function () {
                        that.isAwaiting = false;
                    });
            },
            login(email, pass, rememberMe) {
                var that = this;

                GlobalApp.CartService.getCartId()
                    .then(function (cartId) {
                        return GlobalApp.RdoApiClient.fetchJson("customers/login", {
                            method: 'POST',
                            jBody: {
                                "email": email,
                                "password": pass,
                                "cartId": cartId
                            }
                        });
                    })
                    .then(function (loginDetails) {
                        if (!loginDetails.token)
                            return;

                        that.postLoginRequestToTheLoginFormPage(email, loginDetails.token, rememberMe);
                    });
            },
            postLoginRequestToTheLoginFormPage(email, pass, rememberMe) {
                var rootEl = this.$root.$el;
                var formEl = rootEl.nextElementSibling;
                if (formEl.nodeName !== "FORM")
                    return;

                var inputs = formEl.elements;

                var usernameField = inputs["UserName"];
                usernameField.value = email;

                var passwordField = inputs["Password"];
                passwordField.value = pass;

                var rememberMeField = inputs["RememberMe"];
                rememberMeField.value = rememberMe;

                formEl.submit();
            },
            validateModel() {
                let excludedPropertiesArray = [];
                if (this.model.countryCode !== this.config.usIcoCode) {
                    excludedPropertiesArray.push("zip");
                    excludedPropertiesArray.push("state");
                } else {
                    excludedPropertiesArray.push("postCode");
                    excludedPropertiesArray.push("province");
                }

                return this.model.isValidForAllExcept(excludedPropertiesArray);
            },
            trimModel() {
                ObjectUtils.traversePropertiesAndTransform(this.model,
                    function (propName, value) {
                        return typeof value === 'string';
                    },
                    function (obj, propName, value) {
                        obj[propName] = StringUtils.trimOrEmpty(value);
                    });
            },
            getRegisterRequestBody() {
                var body = this.model.getSubModel();   

                if (this.model.countryCode !== this.config.usIcoCode) {
                    body.state = body.province;
                    body.zip = body.postCode;
                    delete body.province;
                }

                delete body.recaptcha;

                return body;
            },
            switchPasswordVisibility: function switchPasswordVisibility() {
                var that = this;
                if (this.showPassword) {
                    setTimeout(function () {
                        that.showPassword = false;
                    }, 1000);
                }
            },
            businessAccountSelected: function () {
                if (this.config.businessAccountUrl) {
                    this.isAwaiting = true;
                    location.href = this.config.businessAccountUrl
                }
            }
        },       

        components: {
            SelectBranchDropdown,
            Recaptcha,
            PopUp
        }
    });

    return vueApp.$el;
}